// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
// COMPONENTS
import TextContent from './TextContent';
import SignedPDFButton from './SignedPDFButton';
import SendContractModal from './SendContractModal';
import ContractComponent from 'components/common/ContractComponent';
//
// import NedConstants from '/imports/api/constants';
// import formOptions from '../formOptions';
import { contractStatusesObject } from 'lib/constants/contractStatuses';

class SignedPDF extends React.PureComponent {
  state = {
    sendModalVisible: false,
  };

  toggleSendModal = () => {
    // toggle the visible property on the Send Contract modal component
    this.setState({ sendModalVisible: !this.state.sendModalVisible });
  };

  render() {
    const { contract, currentUser, userExists } = this.props;

    const contractorSigned = contract.contractorSignDate; // answers: has the contractor signed the contract?
    const contractWasSent = contract.status && contract.status === contractStatusesObject.awaiting; // answers: has the contract been sent?
    const clientSigned = contract.clientSignDate; // answers:  has the client signed?
    const currentUserIsContractor = currentUser && currentUser._id; // answers: is the current viewer signed in (and presumably he is the contractor)

    return (
      <div style={s.container}>
        {currentUser && (
          <SendContractModal
            contractorSigned={contractorSigned}
            contractWasSent={contractWasSent}
            clientSigned={clientSigned}
            client={contract.client}
            contract={contract}
            onChange={this.props.onChange}
            currentUserIsContractor={currentUserIsContractor}
            toggleSendModal={this.toggleSendModal}
            sendModalVisible={this.state.sendModalVisible}
            onEmailSent={this.props.onEmailSent}
          />
        )}
        <Row gutter={40} type="flex" align="middle" justify="center" style={{ minHeight: 100 }}>
          <Col xs={24} sm={15}>
            <TextContent
              contractorSigned={contractorSigned}
              contractWasSent={contractWasSent}
              clientSigned={clientSigned}
              currentUserIsContractor={currentUserIsContractor}
              contract={contract}
            />
          </Col>
          <Col xs={24} sm={9} style={s.buttonContainer}>
            <SignedPDFButton
              toggleSendModal={this.toggleSendModal}
              contractorSigned={contractorSigned}
              contractWasSent={contractWasSent}
              clientSigned={clientSigned}
              contractId={contract._id}
              contractStatus={contract.status}
              currentUserIsContractor={currentUserIsContractor}
            />
          </Col>
        </Row>
        <div>
          <ContractComponent contract={contract} />
        </div>
      </div>
    );
  }
}

const s = {
  container: {
    maxWidth: '98%',
    width: 1100,
    margin: 'auto',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    minHeight: 100,
  },
};

export default SignedPDF;



// WEBPACK FOOTER //
// ./src/routes/contract-view/SignedPDF/index.js